<template lang="pug">
base-container
  avue-crud(
    ref="crud",
    :data="data",
    :table-loading="loading",
    :option="option",
    :page.sync="page",
    @row-view="handleView",
    @row-update="handleFeedback",
    @search-change="searchChange",
    @search-reset="searchReset",
    @current-change="currentChange",
    @size-change="sizeChange",
    @refresh-change="refreshChange",
    @on-load="onLoad"
  )
    template(slot-scope="{row}", slot="type")
      el-tag(v-if="row.type") {{ row.type | getObjectVal(typeLabel) }}
    template(slot="menu", slot-scope="scope")
      el-button( 
        v-if="scope.row.handleStatus === 0",
        type="text",
        icon="el-icon-edit",
        size="small",
        plain,
        @click.stop="$refs.crud.rowEdit(scope.row)"
      ) 处理
    template(slot-scope="{row}", slot="handleStatus")
      el-tag {{ row.handleStatus === 0 ? '未处理' : '已处理' }}
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
import { getFeedbackList, handleFeedback } from '@/api/content'
import { handleStatusEnum, TYPE_LABEL } from './const'
export default {
  name: 'Feedback',
  components: {},
  data() {
    return {
      form: {},
      data: [],
      query: {},
      typeLabel: TYPE_LABEL,
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        editTitle: '反馈处理',
        editBtnTitle: '处理',
        viewBtn: true,
        delBtn: false,
        editBtn: false,
        addBtn: false,
        searchShow: false,
        columnBtn: false,
        searchBtnText: '查询',
        updateBtnText: '处理',
        emptyBtnText: '重置',
        stripe: true,
        searchSpan: 9,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menuWidth: 200,
        menu: true,
        column: [
          {
            label: '反馈时间',
            prop: 'createDate',
            type: 'datetime',
            width: 160,
            editDetail: true,
            editDisplay: false
          },
          {
            label: '电话',
            prop: 'mobile',
            width: 120,
            editDisplay: false
          },
           {
            label: '举报用户',
            prop: 'userName',
            slot: true,
            width: 80,
            overHidden: true,
            editDisplay: false
          },
              {
            label: '被举报用户',
            prop: 'hisName',
            slot: true,
            width: 90,
            overHidden: true,
            editDisplay: false
          },
          {
            label: '建议内容',
            prop: 'feedback',
            search: true,
            type: 'textarea',
            overHidden: true,
            minRows: 2,
            span: 24,
            editDisabled: true
          },

          {
            label: '反馈图片',
            prop: 'urls',
            span: 24,
            type: 'upload',
            listType: 'picture-card',
            dataType: 'string',
            hide: true,
            overHidden: true,
            editDisplay: true,
            editDisabled: true
          },
        {
            label: '处理意见',
            prop: 'reply',
            span: 24,
            type: 'textarea',
            dataType: 'string',
            hide: true,
            overHidden: true,
            editDisplay: true,
            editDisabled: false
          },
          {
            label: '类型',
            prop: 'type',
            slot: true,
            width: 180,
            overHidden: true,
            editDisplay: false
          },
          {
            label: '是否已处理',
            prop: 'handleStatus',
            slot: true,
            span: 6,
            width: 100,
            type: 'select',
            dicData: handleStatusEnum,
            editDisplay: false
          }
        ]
      }
    }
  },
  methods: {
    handleView(row) {
      console.log('---=====row', row)
    },
    rowUpdate(row) {
      console.log(row)
      this.$refs.crud.rowUpdate()
    },
    handleFeedback(row, index, loading, done) {
      // this.$refs.crud.rowUpdate()
      const { id, reply } = row
      handleFeedback({ id, reply }).then(
        () => {
          loading()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        },
        (error) => {
          done()
          console.log(error)
        }
      )
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      getFeedbackList(page.currentPage, page.pageSize, params)
        .then((res) => {
          const data = res.data
          this.page.total = res.total
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
